module.exports = __webpack_public_path__ + "img/reason16.817ba15d.png";